if (typeof localizationForm === 'undefined') {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul')
      };
      this.querySelectorAll('a[data-value]').forEach(item => {
        item.addEventListener('click', this.onItemClick.bind(this));
      });
    }

    onItemClick(event) {
      if (event.currentTarget.getAttribute('href') && event.currentTarget.getAttribute('href') !== '#') return;
      event.preventDefault();
      const form = this.querySelector('form');
      const input = this.elements.input;
      if (!form || !input) return;

      input.value = event.currentTarget.dataset.value;
      const values = {
        form_type: 'localization',
        utf8: '✓',
        _method: 'put',
        return_to: window.location.pathname + window.location.search
      };
      Object.keys(values).forEach(name => {
        const field = form.querySelector('input[name="' + name + '"]');
        if (field) field.value = values[name];
      });

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onBodyClickEvent(event) {
      if (!this.contains(event.target) && $(event.target).closest('[localization-form__select]').length === 0) {
        this.closeSelector(event);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  var localizationForm = LocalizationForm;
}
